import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Select, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { injectIntl } from 'react-intl';

import stepTabsIcon from '../stepTabsIcon';

const StyledMenuItem = styled(MenuItem)(({ theme }: any) => ({
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,

  '&.Mui-selected, &.Mui-selected > .MuiListItemIcon-root': {
    color: theme.palette.primary.main,
  },
}));

function MobileStepTabs({ onChange, value, tabs, intl }: any) {
  return (
    <Select
      fullWidth
      size="small"
      variant="outlined"
      aria-label={intl.formatMessage({ id: 'POSTS.STEPS.TABS.LABEL' })}
      id="step-tabs-select"
      value={value}
      onChange={(e: any) => onChange(e, e.target.value)}
      renderValue={() => (
        <StyledMenuItem>
          <ListItemIcon>{stepTabsIcon(tabs[value].dates_status)}</ListItemIcon>
          <ListItemText>
            <strong>{tabs[value].label}</strong> {tabs[value].stateLabel}
          </ListItemText>
        </StyledMenuItem>
      )}
    >
      {tabs.map((tab: any, i: any) => (
        <StyledMenuItem value={i} selected={i === value} key={i}>
          <ListItemIcon>{stepTabsIcon(tab.dates_status)}</ListItemIcon>
          <ListItemText>
            <strong>{tab.label}</strong> {tab.stateLabel}
          </ListItemText>
        </StyledMenuItem>
      ))}
    </Select>
  );
}

MobileStepTabs.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      dates_status: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.number.isRequired,
};

export default injectIntl(MobileStepTabs);
